import { Panel, EmptyState } from "@validereinc/common-components";
import { LockSimple } from "@phosphor-icons/react";
import React from "react";

export const CalculatorResultsAccessDeniedPanel = ({
  title,
  message = "You do not have permission to view emissions results.",
}: {
  title: string;
  message?: string;
}) => {
  return (
    <Panel title={title}>
      <EmptyState
        title="Permission required"
        suggestion={message}
        variant="warning"
        icon={<LockSimple />}
      />
    </Panel>
  );
};
